import { Icon } from "@iconify/react";
import React from "react";
import phone from "../constant/phone";

export default function AnimatedCall({ logEvent, analytics }) {
  return (
    <>
      <a href={`tel:${phone}`}>
        <div
          className="pulse"
          onClick={() => {
            logEvent(analytics, "call_footer_button");
            gtag_report_conversion(`tel:${phone}`);
          }}
        >
          <Icon icon="solar:phone-bold" color="#fff" fontSize={30} />
        </div>
      </a>
    </>
  );
}
